import { QrCode } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconQrCode12Line = createIcon(QrCode, 12, "Line");
export const IconQrCode16Line = createIcon(QrCode, 16, "Line");
export const IconQrCode20Line = createIcon(QrCode, 20, "Line");
export const IconQrCode24Line = createIcon(QrCode, 24, "Line");
export const IconQrCode32Line = createIcon(QrCode, 32, "Line");
export const IconQrCode48Line = createIcon(QrCode, 48, "Line");
export const IconQrCode64Line = createIcon(QrCode, 64, "Line");
